var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8788 3.7803L18.4091 3.25M6.21212 3.7803L5.68182 3.25M20.5303 14.3864H21.5909M3.56061 14.3864H2.5M12.0455 19.6894V20.75M16.8108 17.9852L15.794 13.4871C15.7713 13.3867 15.8017 13.2816 15.8745 13.2088L19.4879 9.59547C19.6769 9.40648 19.543 9.08333 19.2757 9.08333H14.8824C14.7687 9.08333 14.6649 9.01913 14.614 8.9175L12.3138 4.31696C12.2032 4.09584 11.8877 4.09584 11.7771 4.31696L9.47685 8.9175C9.42604 9.01913 9.32216 9.08333 9.20853 9.08333H4.81517C4.5479 9.08333 4.41405 9.40648 4.60304 9.59547L8.21638 13.2088C8.28918 13.2816 8.31956 13.3867 8.29686 13.4871L7.28009 17.9852C7.22331 18.2364 7.48862 18.4376 7.71524 18.3153L11.9029 16.0542C11.9919 16.0062 12.099 16.0062 12.188 16.0542L16.3757 18.3153C16.6023 18.4376 16.8676 18.2364 16.8108 17.9852Z",
    stroke: "url(#paint0_linear_1673_22525)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1673_22525",
    x1: 14.997,
    y1: 2.15625,
    x2: 25.7799,
    y2: 16.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.568424fe26f95f1abe7a10c34e6ca11b.svg";
export { ForwardRef as ReactComponent };